import { StateSchema } from "@/lib/data/schemas/CommonSchemaFields";
import { z } from "zod";

export const leadAsideFormSchema = z.object({
  firstName: z.string().trim().min(1, { message: "First name is required" }),
  lastName: z.string().trim().min(1, { message: "Last name is required" }),
  phone: z.string(),
  email: z.string(),
  individualPrimaryLanguage: z.string(),
  individualTimezone: z.string(),
  individualSmsConsent: z.boolean(),
  matterStatusId: z.string().trim().min(1, { message: "Status is required" }),
  claimTypeIds: z.array(z.string()),
  incidentTypeId: z
    .string()
    .trim()
    .min(1, { message: "Incident type is required" }),
  matterDateOfLoss: z.string().refine((value) => value.trim(), {
    message: "Date of loss is required",
  }),
  matterStatuteOfLimitationsDate: z.string(),
  matterIncidentAddressState: StateSchema,
  matterIncidentDescription: z.string(),
  matterClientInjuryDescription: z.string(),
  matterClientSoughtTreatment: z.boolean(),
  matterClientMinor: z.boolean(),
  matterNoteMessage: z.string(),
});

export type LeadAsideFormValues = z.infer<typeof leadAsideFormSchema>;
